import { Modal, Text } from '@patternfly/react-core';
import { useState, useEffect } from 'react';
import CenteredPage from '../../layout/CenteredPage';
import axiosConfig from '../../api/axiosConfig';
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires
const packageJson = require('../../../package.json');
const today = new Date();
const month = (today.getMonth() + 1).toString().padStart(2, '0');
const day = today.getDate().toString().padStart(2, '0');
const year = today.getFullYear();

// Combine them into MM-DD-YYYY format
const defaultDate = `${month}-${day}-${year}`;

type Props = {
	isOpen: boolean;
	onClose: () => void;
};

const formatDate = (dateString: string): string => {
	// Parse the date string directly to avoid timezone issues
	const parts = dateString.split('-');
	if (parts.length === 3) {
		const [year, month, day] = parts;
		return `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;
	}
	return dateString; // Return as-is if format is unexpected
};

function AboutModal(props: Props) {
	const [apiVersion, setApiVersion] = useState<string>('');
	const [apiVersionDate, setApiVersionDate] = useState<string>('');

	useEffect(() => {
		void axiosConfig.instance.get<string>('version').then((response) => {
			const lines = response.data.split('\n');
			if (lines.length >= 2) {
				setApiVersion(lines[0].trim());
				setApiVersionDate(formatDate(lines[1].trim()));
			}
		});
	}, []);

	const message = (
		<>
			<div className="text-center">
				<strong>Frontend:</strong>
				<br />
				{/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
				Version / Release #: {packageJson.version} <br />
				Release Date:{' '}
				{/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-unsafe-argument */}
				{packageJson.version_date ? formatDate(packageJson.version_date) : defaultDate}
				<br />
				<br />
				<strong>API:</strong>
				<br />
				Version / Release #: {apiVersion || 'Loading...'} <br />
				Release Date: {apiVersionDate || 'Loading...'}
				<span className="spacer-sm"></span>
				<Text>(c) {new Date().getFullYear()} ZeroedIn Technologies, LLC.</Text>
			</div>
		</>
	);

	return (
		<>
			<Modal
				title=""
				variant="medium"
				width={350}
				isOpen={props.isOpen}
				onClose={props.onClose}
			>
				<CenteredPage
					description={'ZeroedIn Analytics Platform'}
					notice={message}
					children={undefined}
				></CenteredPage>
			</Modal>
		</>
	);
}

export default AboutModal;
